import { z } from "zod";
import { CheckResultSchema, QualityGateStatusSchema } from "./quality-gate-result.js";
export const VisualQualityGateResultV1Schema = z
    .object({
    schemaVersion: z.literal("visual-quality-gate-result.v1.0"),
    status: QualityGateStatusSchema,
    checks: z.array(CheckResultSchema),
    lensId: z.string().min(1).optional(),
    referenceId: z.string().min(1).optional(),
    componentCoverage: z.array(z.string().min(1)).default([]),
    layoutIndicators: z.array(z.string().min(1)).default([]),
    viewportEvidence: z
        .array(z
        .object({
        viewportId: z.enum(["mobile", "tablet", "desktop"]),
        widthPx: z.number().int().positive(),
        artifactRef: z.string().min(1),
    })
        .strict())
        .min(3)
        .optional(),
    completedAt: z.string().datetime().optional(),
})
    .strict();
//# sourceMappingURL=visual-quality-gate.js.map